import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { object, number } from "yup";
import { getConsultationFee } from "../../../Api/Signin/Transaction.Api";
import useLoadingState from "../../../Utils/Hooks/useLodingState";
import { SideDrawer } from "../../atoms/Drawer/SideDrawer";
import { DcsEditField } from "./Content/DcsEditField";
import { DcsNoContent } from "./Content/DcsNoContent";
import { DcsView } from "./Content/DcsView";

export const DoctorsConsultationSettings = ({ close, OpenDrawer }) => {
  const { t } = useTranslation();
  const onlineForm = useForm({
    defaultValues: { fee: "" },
    resolver: yupResolver(
      object({
        fee: number()
          .typeError(t("validation:required-field"))
          .required(t("validation:required-field"))
          .min(0, t("validation:tax-invalid-character")),
      }),
    ),
    mode: "onChange",
  });
  const onsiteForm = useForm({
    defaultValues: { fee: "" },
    resolver: yupResolver(
      object({
        fee: number()
          .typeError(t("validation:required-field"))
          .required(t("validation:required-field"))
          .min(0, t("validation:tax-invalid-character")),
      }),
    ),
    mode: "onChange",
  });
  const [data, setData] = useState(null);
  const { LoadingState, startLoading, stopLoading } = useLoadingState();
  const [editState, setEditState] = useState({
    online: { sceneID: 0, isUpdate: false, id: "" },
    onsite: { sceneID: 0, isUpdate: false, id: "" },
  });

  const loadConsultationFee = async () => {
    try {
      startLoading({ btnName: "loadConsultationFee" });
      const response = await getConsultationFee();
      if (response.type === 0) {
        setData(response.data);
        onlineForm.reset({ fee: response.data?.onlineConsultationFee?.value?.toString() || "" });
        onsiteForm.reset({ fee: response.data?.onsiteConsultationFee?.value?.toString() || "" });
      } else {
        setData(null);
      }
      stopLoading();
    } catch (exception) {
      console.log(exception);
      stopLoading();
    }
  };

  useEffect(() => {
    if (OpenDrawer) {
      loadConsultationFee();
    }
  }, [OpenDrawer]);

  const contentScreenHandler = (text, data, type) => {
    const state = editState[type];
    const form = type === "online" ? onlineForm : onsiteForm;
    const feeData = type === "online" ? data?.onlineConsultationFee : data?.onsiteConsultationFee;
    if (feeData?.value && state.sceneID === 0) {
      return (
        <DcsView
          t={t}
          data={feeData}
          type={type}
          setContentID={(newState) =>
            setEditState((prev) => ({ ...prev, [type]: newState }))
          }
          reset={() => form.reset({ fee: feeData?.value?.toString() || "" })}
          text={text}
        />
      );
    } else if (state.sceneID === 1) {
      return (
        <DcsEditField
          t={t}
          setError={form.setError}
          handleSubmit={form.handleSubmit}
          control={form.control}
          reset={() => form.reset({ fee: feeData?.value?.toString() || "" })}
          isUpdate={state.isUpdate}
          loadConsultationFee={loadConsultationFee}
          contentOptions={state}
          setContentID={(newState) =>
            setEditState((prev) => ({ ...prev, [type]: newState }))
          }
          type={type}
        />
      );
    } else {
      return (
        <DcsNoContent
          t={t}
          setContentID={(newState) =>
            setEditState((prev) => ({ ...prev, [type]: newState }))
          }
          type={type}
        />
      );
    }
  };

  return (
    <SideDrawer
      headingText={t("glossary:consultation-rate:title")}
      width={"600px"}
      openDrawer={OpenDrawer}
      close={close}
      anchorDrawer={"right"}
      isLoading={LoadingState?.visible ?? false}
    >
      {contentScreenHandler("Online maximum consultation rate", data, "online")}
      {contentScreenHandler("On-site maximum consultation rate", data, "onsite")}
    </SideDrawer>
  );
};